var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterRetwittIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#657786;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,15.7c-0.3-0.3-0.8-0.3-1.1,0l-2.2,2.2V7.7c0-2.1-1.7-3.8-3.8-3.8h-5.9c-0.4,0-0.8,0.3-0.8,0.8 s0.3,0.8,0.8,0.8h5.9c1.2,0,2.2,1,2.2,2.2v10.2l-2.2-2.2c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1l3.5,3.5c0.1,0.1,0.3,0.2,0.5,0.2 s0.4-0.1,0.5-0.2l3.5-3.5C24.1,16.4,24.1,16,23.8,15.7z M13.1,19H7.3C6,19,5,17.9,5,16.7V6.5l2.2,2.2c0.1,0.1,0.3,0.2,0.5,0.2 s0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.8,0-1.1L4.8,4.1C4.5,3.8,4,3.8,3.7,4.1L0.2,7.6c-0.3,0.3-0.3,0.8,0,1.1S1,9,1.3,8.7l2.2-2.2v10.2 c0,2.1,1.7,3.8,3.8,3.8h5.9c0.4,0,0.8-0.3,0.8-0.8S13.5,19,13.1,19L13.1,19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRetwittIcon);
export default __webpack_public_path__ + "static/media/twitter-retwitt-icon.fbc504649428987ee7fb314bffe9b51f.svg";
export { ForwardRef as ReactComponent };